<script setup lang="ts">
import { type TemplateKeysFilters } from '@/types/filters/TemplateFilters'
import { useDebounceFn } from '@vueuse/core'
import DebouncedInputField from '../../../../../components/Fields/DebouncedInputField.vue'
import SelectorField from '../../../../../components/Selector/SelectorField.vue'
import {
    EPropertyType,
    EPropertyTypeLabels,
    EPropertyTypeValues
} from '../../../../../types/enum/PropertyTypeEnum'
import { EDebounceTime } from '../../../../../utils/debounceUtils'

type Props = {
    filters?: TemplateKeysFilters
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: TemplateKeysFilters): void
}
const emit = defineEmits<Emits>()

const handleChange = (value: TemplateKeysFilters) => debouncedChange(value)

const debouncedChange = useDebounceFn(
    (value: TemplateKeysFilters) => emit('change', value),
    EDebounceTime.DEFAULT
)
</script>

<template>
    <DebouncedInputField
        :label="$t('deviceConfig.templateKeys.table.key')"
        @change="$emit('change', { name: $event })" />
    <SelectorField
        :label="$t('deviceConfig.templateKeys.model.type')"
        :modelValue="filters?.property_type"
        :options="
            EPropertyTypeValues.map(value => ({
                label: $t(EPropertyTypeLabels[value]),
                value
            }))
        "
        @change="handleChange({ property_type: $event as EPropertyType })" />
</template>
